import { useCallback, useMemo } from 'react';
import { useLoadFontStyles } from './fonts/useLoadFontStyles';
import { loadCssVarMap as _loadCssVarMap, getBaseFontWasChanged } from '../components/cmv2/utils/globalStyles';
export const useLoadGlobalStyles = ({
  fields,
  globalStyles
}) => {
  const loadCssVarMap = useCallback(newGlobalStyles => {
    _loadCssVarMap(fields, newGlobalStyles);
  }, [fields]);
  const {
    loadFontStyles
  } = useLoadFontStyles({
    fields,
    globalStyles
  });
  const onGlobalStylesUpdate = useCallback((updatedFieldKey, newValue, newGlobalStyles) => {
    if (getBaseFontWasChanged(fields, globalStyles, updatedFieldKey, newValue)) {
      void loadFontStyles(newValue, () => loadCssVarMap(newGlobalStyles));
    } else {
      loadCssVarMap(newGlobalStyles);
    }
  }, [loadCssVarMap, loadFontStyles, fields, globalStyles]);
  return useMemo(() => {
    return {
      onGlobalStylesUpdate,
      loadCssVarMap
    };
  }, [onGlobalStylesUpdate, loadCssVarMap]);
};